import type { StyleLayer } from './utils/types'

export const layers_bikelanes_smooth_default: StyleLayer[] = [
  {
    id: 'smoothness-all',
    type: 'line',
    filter: ['has', 'smoothness'],
    paint: {
      'line-color': [
        'match',
        ['get', 'smoothness'],
        ['very_bad'],
        '#d8035c',
        ['bad'],
        '#f90606',
        ['intermediate'],
        '#faa00f',
        ['good'],
        '#b5ea2e',
        ['excellent'],
        '#37f644',
        'rgba(0, 0, 0, 0)',
      ],
      'line-offset': 1.5,
      'line-opacity': ['interpolate', ['linear'], ['zoom'], 9.9, 0, 10, 0.1, 10.3, 0.9],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 2, 14, 3, 16, 5],
    },
  },
]
